"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_MESSAGE_AUTHOR = exports.AVATAR_INFO = void 0;
var client_1 = require("@apollo/client");
var error_1 = require("@apollo/client/link/error");
var pusher_js_1 = __importDefault(require("pusher-js"));
var ActionFailed_1 = require("../../Actions/ActionFailed");
var GameNotificationsReceived_1 = require("../../Actions/GameNotificationsReceived");
var GameOver_1 = require("../../Actions/GameOver");
var GameStateLoaded_1 = require("../../Actions/GameStateLoaded");
var Failure_1 = __importDefault(require("../../Failure"));
var index_1 = require("../../index");
pusher_js_1.default.Runtime.createXHR = function () {
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    return xhr;
};
exports.AVATAR_INFO = client_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["fragment AvatarInfo on Avataaar {accessoriesType clotheColor clotheType eyeType eyebrowType facialHairType facialHairColor graphicType hairColor mouthType skinColor topType}"], ["fragment AvatarInfo on Avataaar {accessoriesType clotheColor clotheType eyeType eyebrowType facialHairType facialHairColor graphicType hairColor mouthType skinColor topType}"])));
var PLAYERS_TIME = client_1.gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["fragment PlayerTime on Player { time { availableTime cumulatedDownTime cumulatedPlayTime cumulatedWaitForMeTime highestDownTime highestPlayTime lastChange playing weightedWaitForMeTime } }"], ["fragment PlayerTime on Player { time { availableTime cumulatedDownTime cumulatedPlayTime cumulatedWaitForMeTime highestDownTime highestPlayTime lastChange playing weightedWaitForMeTime } }"])));
var NOTIFICATIONS = client_1.gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["fragment Notifications on GameNotification { playerId ... on MovePlayedNotification { moveView consequences } ... on MoveUndoneNotification { moveUndone } ...on RematchNotification { rematchId } }"], ["fragment Notifications on GameNotification { playerId ... on MovePlayedNotification { moveView consequences } ... on MoveUndoneNotification { moveUndone } ...on RematchNotification { rematchId } }"])));
var GET_GAME = client_1.gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["query Game($id: String!) { time game(id: $id) { players { id userId name avatar {...AvatarInfo} gamePointsDelta ...PlayerTime } options { speed maxSpareTime maxExceedTime } notificationsChannel notificationsCount mode setup state myPlayerId endDate } } ", " ", ""], ["query Game($id: String!) { time game(id: $id) { players { id userId name avatar {...AvatarInfo} gamePointsDelta ...PlayerTime } options { speed maxSpareTime maxExceedTime } notificationsChannel notificationsCount mode setup state myPlayerId endDate } } ", " ", ""])), PLAYERS_TIME, exports.AVATAR_INFO);
var GET_NOTIFICATIONS = client_1.gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["query GameNotifications($gameId: String!, $start: Int) { time gameNotifications(gameId: $gameId, start: $start) { ...Notifications } game(id: $gameId) { players { id ...PlayerTime } } } ", " ", ""], ["query GameNotifications($gameId: String!, $start: Int) { time gameNotifications(gameId: $gameId, start: $start) { ...Notifications } game(id: $gameId) { players { id ...PlayerTime } } } ", " ", ""])), NOTIFICATIONS, PLAYERS_TIME);
var PLAY = client_1.gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["mutation PlayMoves($gameId: String!, $moves: [JSON!]!) { playMoves(gameId: $gameId, moves: $moves) { notifications { ...Notifications } index players { id ...PlayerTime } date } } ", " ", ""], ["mutation PlayMoves($gameId: String!, $moves: [JSON!]!) { playMoves(gameId: $gameId, moves: $moves) { notifications { ...Notifications } index players { id ...PlayerTime } date } } ", " ", ""])), NOTIFICATIONS, PLAYERS_TIME);
var UNDO = client_1.gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["mutation UndoLastMove($gameId: String!, $playerActionsIndexes: [Int!]!) { undoMoves(gameId: $gameId, playerActionsIndexes: $playerActionsIndexes) { notifications { ...Notifications } index players { id ...PlayerTime } date } } ", " ", ""], ["mutation UndoLastMove($gameId: String!, $playerActionsIndexes: [Int!]!) { undoMoves(gameId: $gameId, playerActionsIndexes: $playerActionsIndexes) { notifications { ...Notifications } index players { id ...PlayerTime } date } } ", " ", ""])), NOTIFICATIONS, PLAYERS_TIME);
var REMATCH = client_1.gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["mutation Rematch($gameId: String!) { rematch(gameId: $gameId) { notifications { ...Notifications } index players { id ...PlayerTime } date } } ", " ", ""], ["mutation Rematch($gameId: String!) { rematch(gameId: $gameId) { notifications { ...Notifications } index players { id ...PlayerTime } date } } ", " ", ""])), NOTIFICATIONS, PLAYERS_TIME);
var EJECT_PLAYER = client_1.gql(templateObject_9 || (templateObject_9 = __makeTemplateObject(["mutation EjectPlayer($gameId: String!, $playerId: JSON!) { ejectPlayer(gameId: $gameId, playerId: $playerId) { notifications { ...Notifications } index players { id ...PlayerTime } date } } ", " ", ""], ["mutation EjectPlayer($gameId: String!, $playerId: JSON!) { ejectPlayer(gameId: $gameId, playerId: $playerId) { notifications { ...Notifications } index players { id ...PlayerTime } date } } ", " ", ""])), NOTIFICATIONS, PLAYERS_TIME);
var GIVE_UP = client_1.gql(templateObject_10 || (templateObject_10 = __makeTemplateObject(["mutation GiveUp($gameId: String!) { giveUp(gameId: $gameId) { notifications { ...Notifications } index players { id ...PlayerTime } date } } ", " ", ""], ["mutation GiveUp($gameId: String!) { giveUp(gameId: $gameId) { notifications { ...Notifications } index players { id ...PlayerTime } date } } ", " ", ""])), NOTIFICATIONS, PLAYERS_TIME);
exports.GET_MESSAGE_AUTHOR = client_1.gql(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    query GetMessageAuthor($id: String!) {\n        user(id: $id) {\n            id name avatar {...AvatarInfo}\n        }\n    } ", "\n"], ["\n    query GetMessageAuthor($id: String!) {\n        user(id: $id) {\n            id name avatar {...AvatarInfo}\n        }\n    } ", "\n"])), exports.AVATAR_INFO);
var GameClientAPI = /** @class */ (function () {
    function GameClientAPI(gameId) {
        var _this = this;
        var _a, _b, _c, _d;
        this.pendingActions = [];
        this.nextNotificationIndex = 0;
        this.errorLink = error_1.onError(function (_a) {
            var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
            if (graphQLErrors) {
                graphQLErrors.map(function (_a) {
                    var message = _a.message;
                    return _this.dispatch(ActionFailed_1.actionFailed(message));
                });
            }
            if (networkError) {
                console.error(networkError);
                _this.dispatch(ActionFailed_1.actionFailed(Failure_1.default.NETWORK));
            }
        });
        this.gameId = gameId;
        var uri = index_1.PLATFORM_URI + ((_a = process.env.REACT_APP_GRAPHQL_ENDPOINT) !== null && _a !== void 0 ? _a : '/api/graphql');
        var httpLink = new client_1.HttpLink({ uri: uri, fetch: fetch, credentials: 'include' });
        this.apolloClient = new client_1.ApolloClient({
            link: client_1.ApolloLink.from([this.errorLink, httpLink]),
            cache: new client_1.InMemoryCache(),
            defaultOptions: {
                watchQuery: {
                    fetchPolicy: 'no-cache'
                },
                query: {
                    fetchPolicy: 'no-cache' // TODO: configure fragment matchers for Interface types and re-enable caching
                }
            }
        });
        var authEndpoint = index_1.PLATFORM_URI + ((_b = process.env.REACT_APP_PUSHER_ENDPOINT) !== null && _b !== void 0 ? _b : '/api/pusher/auth');
        this.pusher = new pusher_js_1.default((_c = process.env.REACT_APP_PUSHER_KEY) !== null && _c !== void 0 ? _c : '747557f1e8edf7fc2816', {
            cluster: (_d = process.env.REACT_APP_PUSHER_CLUSTER) !== null && _d !== void 0 ? _d : 'eu',
            authEndpoint: authEndpoint,
            forceTLS: true
        });
    }
    GameClientAPI.prototype.init = function (dispatch) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var gameResponse, gameData;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.dispatch = dispatch;
                        return [4 /*yield*/, this.apolloClient.query({ query: GET_GAME, variables: { id: this.gameId } })];
                    case 1:
                        gameResponse = _b.sent();
                        if (!gameResponse.data) {
                            return [2 /*return*/, console.error('Failed to collect game data')];
                        }
                        gameData = gameResponse.data.game;
                        this.dispatch(GameStateLoaded_1.gameStateLoaded(gameData, gameResponse.data.time));
                        this.notificationsChannel = this.pusher.subscribe((_a = gameData.notificationsChannel) !== null && _a !== void 0 ? _a : "game=" + this.gameId);
                        this.notificationsChannel.bind('pusher:subscription_error', function (error) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                console.error('pusher subscription failed', error);
                                return [2 /*return*/];
                            });
                        }); });
                        this.notificationsChannel.bind('pusher:subscription_succeeded', function () { return __awaiter(_this, void 0, void 0, function () {
                            var start, notificationsResponse, notifications;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        start = this.nextNotificationIndex;
                                        return [4 /*yield*/, this.apolloClient.query({
                                                query: GET_NOTIFICATIONS,
                                                variables: { gameId: this.gameId, start: start }
                                            })];
                                    case 1:
                                        notificationsResponse = _a.sent();
                                        if (!notificationsResponse.data) {
                                            return [2 /*return*/, console.error('Failed to collect game data')];
                                        }
                                        notifications = notificationsResponse.data.gameNotifications;
                                        this.dispatch(GameNotificationsReceived_1.gameNotificationsReceived(notifications, start, notificationsResponse.data.game.players, notificationsResponse.data.time));
                                        if (notifications.length > 0) {
                                            this.nextNotificationIndex = Math.max(this.nextNotificationIndex, start + notifications.length);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this.notificationsChannel.bind('moves-played', function (_a) {
                            var index = _a.index, notifications = _a.notifications, players = _a.players, date = _a.date;
                            _this.dispatch(GameNotificationsReceived_1.gameNotificationsReceived(notifications, index, players, Date.parse(date)));
                            _this.nextNotificationIndex = Math.max(_this.nextNotificationIndex, index + notifications.length);
                        });
                        this.notificationsChannel.bind('game-over', function (players) {
                            _this.dispatch(GameOver_1.gameOver(players));
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    GameClientAPI.prototype.play = function (move) {
        var _this = this;
        if (this.pendingActions.length === 0) {
            this.pendingActions.push({ type: 'PLAY', moves: [move] });
        }
        else {
            var lastPendingAction = this.pendingActions[this.pendingActions.length - 1];
            if (lastPendingAction.type === 'PLAY') {
                lastPendingAction.moves.push(move);
            }
            else {
                this.pendingActions.push({ type: 'PLAY', moves: [move] });
            }
        }
        if (!this.ongoingAction) {
            // Wait for 50ms before sending this move: maybe more moves are coming very soon
            this.ongoingAction = new Promise(function (resolve) { return setTimeout(resolve, 50); }).then(function () { return _this.executePendingActions(); });
        }
    };
    GameClientAPI.prototype.undo = function (playerActionIndex) {
        if (this.pendingActions.length === 0) {
            this.pendingActions.push({ type: 'UNDO', playerActionsIndexes: [playerActionIndex] });
        }
        else {
            var lastPendingAction = this.pendingActions[this.pendingActions.length - 1];
            if (lastPendingAction.type === 'UNDO') {
                lastPendingAction.playerActionsIndexes.push(playerActionIndex);
            }
            else {
                this.pendingActions.push({ type: 'UNDO', playerActionsIndexes: [playerActionIndex] });
            }
        }
        if (!this.ongoingAction) {
            this.executePendingActions();
        }
    };
    GameClientAPI.prototype.executePendingActions = function () {
        var _this = this;
        if (this.pendingActions.length > 0) {
            var pendingAction = this.pendingActions.shift();
            if (pendingAction.type == 'PLAY') {
                this.ongoingAction = this.apolloClient.mutate({
                    mutation: PLAY, variables: { gameId: this.gameId, moves: pendingAction.moves }
                })
                    .then(function (result) { return result.data && _this.handleGameMessageResult(result.data.playMoves); });
            }
            else {
                this.ongoingAction = this.apolloClient.mutate({
                    mutation: UNDO, variables: { gameId: this.gameId, playerActionsIndexes: pendingAction.playerActionsIndexes }
                })
                    .then(function (result) { return result.data && _this.handleGameMessageResult(result.data.undoMoves); });
            }
            this.ongoingAction = this.ongoingAction.catch(function () {
            }).finally(function () { return _this.executePendingActions(); });
        }
        else {
            delete this.ongoingAction;
        }
    };
    GameClientAPI.prototype.handleGameMessageResult = function (_a) {
        var date = _a.date, index = _a.index, notifications = _a.notifications, players = _a.players;
        this.dispatch(GameNotificationsReceived_1.gameNotificationsReceived(notifications, index, players, Date.parse(date)));
    };
    GameClientAPI.prototype.rematch = function () {
        var _this = this;
        return this.apolloClient.mutate({ mutation: REMATCH, variables: { gameId: this.gameId } }).then(function (result) {
            if (!result.data) {
                throw new Error('Rematch request failed');
            }
            if (result.data.rematch.index > 0) {
                // We stimulate that we received the notification for retro-compatibility. The rematched feature can be refactored into a simpler version in the future.
                _this.handleGameMessageResult(result.data.rematch);
            }
            return result.data.rematch.notifications[0];
        });
    };
    GameClientAPI.prototype.eject = function (playerId) {
        var _this = this;
        this.apolloClient.mutate({ mutation: EJECT_PLAYER, variables: { gameId: this.gameId, playerId: playerId } })
            .then(function (result) { return result.data && _this.handleGameMessageResult(result.data.ejectPlayer); });
    };
    GameClientAPI.prototype.giveUp = function () {
        var _this = this;
        this.apolloClient.mutate({ mutation: GIVE_UP, variables: { gameId: this.gameId } })
            .then(function (result) { return result.data && _this.handleGameMessageResult(result.data.giveUp); });
    };
    GameClientAPI.prototype.playTutorialMoves = function () {
        console.error('Tutorial should only be played with local API');
    };
    return GameClientAPI;
}());
exports.default = GameClientAPI;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
//# sourceMappingURL=GameClientAPI.js.map